// extracted by mini-css-extract-plugin
module.exports = {"summary":"Sumarry_summary__2NCfm","point":"Sumarry_point__3mHV3","score":"Sumarry_score__2Gx1T","badge":"Sumarry_badge__1khIj"};